import styled from '@emotion/styled'

type TextDivProps = {
  data: string | null | undefined
}

export const ExtranetTextDiv = styled.div<TextDivProps>`
  overflow-wrap: break-word;
  hyphens: auto;
  width: 100%;
  font-family: var(--font-family-primary);
  color: ${(props) => (!props.data ? 'var(--color-red)' : 'var(--color-accent-8)')};
  p {
    font-size: 16px;
  }
  ol,
  ul {
    padding-left: 1.5em;
  }
`
